<form [formGroup]="form" (ngSubmit)="onFormSubmit()" fxLayout="column" fxFlex="1 0 auto">
    <div fxLayout="row" fxFlex="1 1 auto" class="neq-page-wrapper">
      <div class="neq-container" fxLayout="column" fxFlex>
        <div fxLayout="row">
          <div fxFlex="30">
            <mat-form-field>
              <input select-all matInput [formControlName]="'familyName'" [placeholder]="'label.admin.user.family-name' | translate" required>
            </mat-form-field>
          </div>

          <div fxFlex="30">
            <mat-form-field>
              <input select-all matInput [formControlName]="'givenName'" [placeholder]="'label.admin.user.given-name' | translate" required>
            </mat-form-field>
          </div>

          <div fxFlex="40">
            <mat-form-field>
              <input select-all matInput [formControlName]="'email'" [placeholder]="'label.admin.user.email' | translate" required>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row">
          <div fxFlex="20">
            <mat-form-field>
              <mat-select formControlName="langCode" [placeholder]="'label.admin.user.lang' | translate" required>
                <mat-option *ngFor="let lang of langs" [value]="lang.code">
                  {{ lang.code }} - {{ lang.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="column" fxLayoutGap="0.714rem" class="user-small-text-size">
          <div>
            {{ 'label.user.account.contact-admin-to-update-infos'  | translate }}
          </div>

          <mat-checkbox  [checked]="true" [disabled]="true" class="mat-checkbox-terms-acceptance">
            <span [innerHTML]="messageCheckboxTerms"></span>
          </mat-checkbox>

          <mat-checkbox formControlName="personalDataAcceptance">
            <span [innerHTML]="messageCheckboxPersonalData"></span>
          </mat-checkbox>

          <button id="ot-sdk-btn" class="ot-sdk-show-settings">
            {{ 'label.common.cookies-settings' | translate }}
          </button>
        </div>
      </div>

      <aside>
        <div fxLayoutAlign="end center" class="neq-action-button" style="word-break: break-word;">
          <button pButton
            [disabled]="form.pristine"
            class="neq-primeng-button primeng-flat"
            [matTooltip]="'msg.common.icon.save' | translate" type="submit"
          >
            <neq-icon svgIcon="enregistrer"></neq-icon>
          </button>
        </div>
      </aside>
    </div>
  </form>
